<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <div class="carBox">
            <div class="mainBody">
                <div class="searchBox">
                    <el-button type="primary"  @click="selProjects">添加选中</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="orgname" label="项目名称" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" plain type="primary" @click="selThis(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import { getListData } from '@/api/common'

export default {
    name: "roleList",
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        user_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.user_id = this.user_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '分配角色',
            menu_id: 1220,
            list_url: "/api/admin/userproject/orgList",
            search_Obj: {
                org_id: '',
            },
            del_Obj:{
                url:'/api/admin/role/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            showflag: false,
        };
    },
    mounted() {},
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        selThis(obj){
            this.$emit("selectProject", obj.id)
        },
        selProjects(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要添加的角色")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                this.$emit("selectProject", ids)
            }
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data;
                }
            })
        },
    }
};
</script>